import { ColouredMarkers } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { useSuccessFailColouring } from '@/hooks/useSuccessFailColouring';

export const EventMapMarkerLegend = () => {
  const { t } = useTranslation('visualisation');
  const successFailColouring = useSuccessFailColouring();

  return (
    <ColouredMarkers
      title={t('markerColouring.outcome')}
      markers={[
        {
          label: t('outcomeLegend.success'),
          colour: successFailColouring.success,
        },
        { label: t('outcomeLegend.fail'), colour: successFailColouring.fail },
        {
          label: t('outcomeLegend.neutral'),
          colour: successFailColouring.neutral,
        },
      ]}
    />
  );
};
